import { cn, insertObjectIf } from '@/utils';
import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import { TableLinkTo } from '..';
import Button from '../common/button';
import DefineDocumentWrite from '.';
import {
	DefineDocumentWriteButtonProps,
	IProps as IDefineDocumentWriteProps,
} from './define-document-write.type';

const DefineDocumentWriteButton = (props: DefineDocumentWriteButtonProps) => {
	const { className, label = '추가', link, readonly, ...restProps } = props;

	const [open, setOpen] = useState(false);

	const defineDocumentWriteModal =
		useRef<FunctionComponent<IDefineDocumentWriteProps>>();

	const onOpenModal = useCallback(() => {
		if (!defineDocumentWriteModal.current) {
			defineDocumentWriteModal.current = DefineDocumentWrite;
		}

		setOpen(true);
	}, []);

	const onCloseModal = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<>
			{link ? (
				<TableLinkTo
					label={label}
					{...insertObjectIf(!readonly, {
						onClick: onOpenModal,
					})}
				/>
			) : (
				<Button
					secondary
					className={cn('min-w-0', className)}
					onClick={onOpenModal}
				>
					{label}
				</Button>
			)}

			{defineDocumentWriteModal.current && (
				<defineDocumentWriteModal.current
					{...{ ...restProps, open, onCloseModal }}
				/>
			)}
		</>
	);
};

export default memo(DefineDocumentWriteButton);
